'use client';

import { UAParser } from 'ua-parser-js';

export const { browser, os, engine, ua, cpu, device } = UAParser();
